import React, { useEffect, useState } from "react";
import { API_URL } from "../config";
import axios from "axios";
import { motion } from "framer-motion";
import {
  ChevronLeft,
  ChevronRight,
  LogOut,
  MessageCircle,
  Users,
  Car,
  FileText,
  Search,
  Bell,
  BarChart2,
  BarChart3,
  Settings,
  Home,
  CreditCard,
  Radio,
  Map,
  Send,
  DollarSign,
  Sliders,
  Clock,
  Activity,
  Navigation,
  TrendingUp,
  User,
  Globe,
  Heart,
  Award,
  Route,
  Trophy,
  MapPin,
  Gift,
  Wallet,
  Key,
  Shield,
  AlertTriangle,
  Scale,
  Cog,
  Wrench,
} from "lucide-react";

const SideBar = ({ collapsed, setCollapsed }) => {
  // Accept collapsed as a prop
  const [counts, setCounts] = useState({
    customers: 0,
    trips: 0,
    drivers: 0,
    pending: 0,
    newTrips: 0,
  });
  const [activeSection, setActiveSection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(false);

  const APILINK = API_URL;

  const fetchJsonSafe = async (url) => {
    try {
      const res = await fetch(url);
      if (!res.ok) return [];
      return await res.json();
    } catch (e) {
      return [];
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [trips, newTrips, pending, drivers, customers] = await Promise.all([
        fetchJsonSafe(`${APILINK}/trip/`),
        fetchJsonSafe(
          `${APILINK}/trip/tripsbystatus/${encodeURIComponent("New Order")}`
        ),
        fetchJsonSafe(
          `${APILINK}/driver/driver_status/${encodeURIComponent(
            "Pending Verification"
          )}`
        ),
        fetchJsonSafe(`${APILINK}/driver/`),
        axios.get(`${APILINK}/customerdetails/`).then((res) => res.data),
      ]);
      console.log("ggggg", pending);
      setCounts({
        trips: trips.length,
        newTrips: newTrips.length,
        pending: pending.length,
        drivers: drivers.length,
        customers: customers.length,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 7000);
    return () => clearInterval(interval);
  }, []);

  const menuSections = [
    {
      title: "Dashboard",
      items: [
        {
          name: "Admin Dashboard",
          path: "/Admindash",
          icon: <Activity size={18} />,
          count: null,
        },
        {
          name: "Heat Map Ride Demand",
          path: "/heatmap-ride-demand",
          icon: <Activity size={18} />,
          count: null,
        },
        {
          name: "Active Drivers Locations Map",
          path: "/active-drivers-locations-map",
          icon: <Radio size={18} />,
          count: null,
        },
        {
          name: "Customer Map",
          path: "/customers-map",
          icon: <Map size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "User Management",
      items: [
        {
          name: "Customers",
          path: "/Customerstable/list",
          icon: <Users size={18} />,
          count: counts.customers,
        },
        {
          name: "Customers Filter Table",
          path: "/Customers",
          icon: <Users size={18} />,
          count: counts.customers,
        },
        {
          name: "Drivers",
          path: "/Driverstable/list",
          icon: <Car size={18} />,
          count: counts.drivers,
        },
        {
          name: "Drivers Filter Table",
          path: "/Drivers",
          icon: <Car size={18} />,
          count: null,
        },
        {
          name: "Pending Driver Verification",
          path: "/verifyReg",
          icon: <Bell size={18} />,
          count: counts.pending,
        },
        {
          name: "Search User",
          path: "/search",
          icon: <Search size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Trip Management",
      items: [
        {
          name: "All Trips",
          path: "/trips",
          icon: <Navigation size={18} />,
          count: counts.trips,
        },
        {
          name: "Trips Filter Table",
          path: "/TripsFilter",
          icon: <Navigation size={18} />,
          count: counts.trips,
        },
        {
          name: "Trips Time Filter",
          path: "/TripsByTime",
          icon: <Navigation size={18} />,
          count: counts.trips,
        },
        {
          name: "Allocate Trips",
          path: "/TripAllocate",
          icon: <Send size={18} />,
          count: counts.newTrips,
        },
        {
          name: "Search Trip",
          path: "/searchTrip",
          icon: <Search size={18} />,
          count: null,
        },
        {
          name: "Trip Tracking",
          path: "/DashTracker/1",
          icon: <Map size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Finance & Payments",
      items: [
        {
          name: "Account Top Up",
          path: "/billing",
          icon: <CreditCard size={18} />,
          count: null,
        },
        {
          name: "Transactions",
          path: "/GroupedTransactionTable",
          icon: <DollarSign size={18} />,
          count: null,
        },
        {
          name: "Billing Reports",
          path: "/GroupedTransactionTable",
          icon: <FileText size={18} />,
          count: null,
        },
        {
          name: "PesePay Integration",
          path: "/pesepay",
          icon: <DollarSign size={18} />,
          count: null,
        },
        {
          name: "Enhanced Promotions",
          path: "/enhanced-promotions",
          icon: <Gift size={18} />,
          count: null,
        },
        {
          name: "Withdrawal Management",
          path: "/withdrawal-management",
          icon: <Wallet size={18} />,
          count: null,
        },
        {
          name: "Payment Reconciliation",
          path: "/payment-reconciliation",
          icon: <FileText size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Analytics & Reports",
      items: [
        {
          name: "Analytics Dashboard",
          path: "/analytics",
          icon: <BarChart2 size={18} />,
          count: null,
        },
        {
          name: "Customer Analytics",
          path: "/customer-analytics-dashboard",
          icon: <Users size={18} />,
          count: null,
        },
        {
          name: "Driver Analytics",
          path: "/driver-analytics-dashboard",
          icon: <Car size={18} />,
          count: null,
        },
        {
          name: "Driver Earnings",
          path: "/driver-earnings",
          icon: <Wallet size={18} />,
          count: null,
        },
        {
          name: "Customer Performance",
          path: "/customer-performance",
          icon: <User size={18} />,
          count: null,
        },
        {
          name: "Comprehensive Analytics",
          path: "/comprehensive-analytics",
          icon: <BarChart3 size={18} />,
          count: null,
        },
        {
          name: "Notification Analytics",
          path: "/notification-analytics",
          icon: <Bell size={18} />,
          count: null,
        },
        {
          name: "Funnel Analysis",
          path: "/funnel",
          icon: <TrendingUp size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Statistics & Monitoring",
      items: [
        {
          name: "App Statistics",
          path: "/AppStatistics",
          icon: <Activity size={18} />,
          count: null,
        },
        {
          name: "Statistics Cards",
          path: "/StatCards",
          icon: <Activity size={18} />,
          count: null,
        },
        {
          name: "Statistics Charts",
          path: "/statsCharts",
          icon: <Activity size={18} />,
          count: null,
        },
        {
          name: "General Statistics",
          path: "/stats",
          icon: <Activity size={18} />,
          count: null,
        },
        {
          name: "Hourly Statistics",
          path: "/hourly",
          icon: <Clock size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "System Configuration",
      items: [
        {
          name: "Configurations",
          path: "/Configurations",
          icon: <Sliders size={18} />,
          count: null,
        },
        {
          name: "Realtime Settings",
          path: "/commission-control",
          icon: <Settings size={18} />,
          count: null,
        },
        {
          name: "Detour Distance Control",
          path: "/detour-distance-control",
          icon: <MapPin size={18} />,
          count: null,
        },
        {
          name: "Enhanced Driver Analytics",
          path: "/enhanced-driver-analytics",
          icon: <Trophy size={18} />,
          count: null,
        },
        {
          name: "Service Vehicle Type Management",
          path: "/vehicle-management",
          icon: <Car size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Communication",
      items: [
        {
          name: "Feedback Management",
          path: "/feedback",
          icon: <FileText size={18} />,
          count: null,
        },
        {
          name: "Broadcast to Drivers",
          path: "/broadcast",
          icon: <Radio size={18} />,
          count: null,
        },
        {
          name: "Broadcast to Customers",
          path: "/BroadcastCust",
          icon: <Radio size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Support & Tickets",
      items: [
        {
          name: "Create Ticket",
          path: "/TicketCreationPage",
          icon: <Search size={18} />,
          count: null,
        },
        {
          name: "Assign Chats",
          path: "/AllocateChats",
          icon: <Search size={18} />,
          count: null,
        },
        {
          name: "Assign Tickets",
          path: "/AllocateTickets",
          icon: <Sliders size={18} />,
          count: null,
        },
        {
          name: "Customer Service Chats",
          path: "/CustomerServiceHome",
          icon: <Sliders size={18} />,
          count: null,
        },
        {
          name: "Assigned Tickets",
          path: "/tickets",
          icon: <Sliders size={18} />,
          count: null,
        },
      ],
    },
    // Vehicle Rental Management Section
    {
      title: "Vehicle Rental Management",
      icon: <Car />,
      items: [
        {
          name: "Vehicle Rental Dashboard",
          path: "/vehicle-rental-management",
          icon: <Car size={18} />,
          count: null,
        },
        {
          name: "Vehicle Maintenance Schedule",
          path: "/vehicle-maintenance",
          icon: <Wrench size={18} />,
          count: null,
        },
      ],
    },
    // Teller Operations Section
    {
      title: "Teller Operations",
      icon: <Scale />,
      items: [
        {
          name: "Teller Control Panel",
          path: "/teller-control-panel",
          icon: <Scale size={18} />,
          count: null,
        },
      ],
    },
    // Driver Configuration Section
    {
      title: "Driver Configuration",
      icon: <Cog />,
      items: [
        {
          name: "Driver Configuration Management",
          path: "/driver-configuration",
          icon: <Cog size={18} />,
          count: null,
        },
      ],
    },
    {
      title: "Performance Reports",
      icon: <BarChart3 />,
      items: [
        {
          name: "Performance Dashboard",
          path: "/performance-reports",
          icon: <TrendingUp />,
          count: null,
        },
        {
          name: "Trips Status Report",
          path: "/trips-status-report",
          icon: <Activity />,
          count: null,
        },
        {
          name: "Geographic Performance",
          path: "/geographic-report",
          icon: <Globe />,
          count: null,
        },
        {
          name: "Peak Hours Analysis",
          path: "/peak-hours-report",
          icon: <Clock />,
          count: null,
        },
        {
          name: "Revenue Breakdown",
          path: "/revenue-breakdown-report",
          icon: <DollarSign />,
          count: null,
        },
        {
          name: "Driver Performance",
          path: "/driver-performance-report",
          icon: <Users />,
          count: null,
        },
        {
          name: "Customer Analytics & Retention",
          path: "/customer-analytics-report",
          icon: <Heart />,
          count: null,
        },
        {
          name: "Customer Performance",
          path: "/customer-performance-report",
          icon: <Award />,
          count: null,
        },
        {
          name: "Rideshare Analytics",
          path: "/rideshare-analytics-report",
          icon: <Car />,
          count: null,
        },
        {
          name: "Private Ride Analytics",
          path: "/private-ride-analytics-report",
          icon: <Map />,
          count: null,
        },
        {
          name: "Top 20 Drivers by Trips",
          path: "/toptwentydriverscount",
          icon: <Users />,
          count: null,
        },
        {
          name: "Top 20 Customers by Trips",
          path: "/toptwentycustomerscount",
          icon: <Users />,
          count: null,
        },
        {
          name: "Lowest 20 Drivers by Trips",
          path: "/lowtwentydriverscount",
          icon: <Search size={18} />,
          count: null,
        },
        {
          name: "Lowest 20 Customers by Trips",
          path: "/lowtwentycustomerscount",
          icon: <Search size={18} />,
          count: null,
        },
      ],
    },
  ];

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  return (
    <motion.div
      className={`relative ${
        darkMode ? "bg-[#002966] text-gray-100" : "bg-[#002966] text-gray-800"
      } h-screen `}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div
        className={`flex items-center justify-between p-4 ${
          darkMode ? "border-gray-700" : "border-gray-200"
        } border-b`}
      >
        {!collapsed && (
          <motion.h2
            className={`text-xl font-bold ${
              darkMode ? "text-yellow-400" : "text-yellow-500"
            }`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            ADMIN
          </motion.h2>
        )}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setCollapsed(!collapsed)}
          className={`p-2 rounded-full ${
            darkMode
              ? "bg-gray-800 hover:bg-gray-700"
              : "bg-white hover:bg-gray-200"
          } shadow-md`}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </motion.button>
      </div>

      <div className="mt-2">
        <div
          className={`overflow-y-auto ${
            collapsed ? "h-[calc(100vh-140px)]" : "h-[calc(100vh-180px)]"
          } custom-scrollbar`}
        >
          {menuSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="mb-2">
              {!collapsed && (
                <div
                  className={`px-4 py-2 text-xs font-semibold ${
                    darkMode ? "text-white" : "text-white"
                  } uppercase cursor-pointer flex items-center justify-between`}
                  onClick={() => toggleSection(sectionIndex)}
                >
                  {section.title}
                  <ChevronRight
                    size={14}
                    className={`transform transition-transform duration-200 ${
                      activeSection === sectionIndex ? "rotate-90" : ""
                    }`}
                  />
                </div>
              )}

              <motion.div
                animate={{
                  height: collapsed
                    ? "auto"
                    : activeSection === sectionIndex
                    ? "auto"
                    : "0px",
                  opacity: collapsed
                    ? 1
                    : activeSection === sectionIndex
                    ? 1
                    : 0,
                }}
                transition={{ duration: 0.3 }}
                className={`overflow-hidden ${
                  !collapsed && activeSection !== sectionIndex ? "h-0" : ""
                }`}
              >
                {section.items.map((item, itemIndex) => (
                  <motion.a
                    key={itemIndex}
                    href={item.path}
                    whileHover={{ x: 5 }}
                    className={`text-white flex items-center justify-between ${
                      collapsed ? "px-3 py-4" : "px-4 py-3"
                    } my-1 mx-2 rounded-lg  transition-all duration-200`}
                  >
                    <div className="flex items-center">
                      <div
                        className={`${
                          darkMode ? "text-yellow-400" : "text-yellow-500"
                        }`}
                      >
                        {item.icon}
                      </div>
                      {!collapsed && (
                        <span className="ml-3 text-white-sm font-medium">
                          {item.name}
                        </span>
                      )}
                    </div>
                    {!collapsed && item.count !== null && (
                      <motion.div
                        className={`${darkMode ? "bg-gray-800" : "bg-white"} ${
                          item.count > 0
                            ? darkMode
                              ? "text-yellow-400"
                              : "text-yellow-500"
                            : "text-gray-400"
                        } text-xs font-bold px-2 py-1 rounded-full shadow-inner`}
                        initial={{ scale: 0.8 }}
                        animate={{ scale: 1 }}
                        transition={{ type: "spring", stiffness: 500 }}
                      >
                        {item.count}
                      </motion.div>
                    )}
                    {collapsed && item.count !== null && item.count > 0 && (
                      <motion.div
                        className={`absolute top-1 right-1 ${
                          darkMode ? "bg-yellow-500" : "bg-yellow-500"
                        } w-2 h-2 rounded-full`}
                        animate={{ scale: [1, 1.2, 1] }}
                        transition={{ repeat: Infinity, duration: 2 }}
                      />
                    )}
                  </motion.a>
                ))}
              </motion.div>
            </div>
          ))}
        </div>
      </div>

      <div
        className={`absolute bottom-0 left-0 right-0 ${
          darkMode ? "border-gray-700" : "border-gray-200"
        } border-t p-3 flex flex-col gap-2`}
      >
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => setCollapsed(!collapsed)}
          className={`p-2 rounded-full ${
            darkMode
              ? "bg-gray-800 hover:bg-gray-700"
              : "bg-white hover:bg-gray-200"
          } shadow-md`}
        >
          {collapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </motion.button>

        <motion.a
          href="#"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className={`flex items-center justify-center ${
            collapsed ? "p-3" : "p-2 px-4"
          } rounded-lg ${
            darkMode
              ? "bg-red-900 hover:bg-red-800 text-white"
              : "bg-red-600 hover:bg-red-700 text-white"
          } shadow-md transition-all duration-200`}
        >
          {collapsed ? (
            <LogOut size={20} />
          ) : (
            <div className="flex items-center justify-between w-full">
              <span className="text-sm font-medium">LOGOUT</span>
              <LogOut size={18} />
            </div>
          )}
        </motion.a>
      </div>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: ${darkMode ? "#1a1a1a" : "#f1f1f1"};
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: ${darkMode ? "#333" : "#ccc"};
          border-radius: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: ${darkMode ? "#555" : "#aaa"};
        }
      `}</style>
    </motion.div>
  );
};

export default SideBar;
